const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");
const isProdBuild = String(process.env.NODE_ENV || "").toLowerCase() === "production";

// Prefer explicit envs, then backend url, then window origin, then localhost.
const envBackend = trimTrailingSlash(process.env.REACT_APP_BACKEND_URL);
const envFrontend = trimTrailingSlash(process.env.REACT_APP_FRONTEND_URL);
const envApiBase = trimTrailingSlash(process.env.REACT_APP_API_BASE_URL);

const defaultFrontend = (() => {
  if (envFrontend) return envFrontend;
  if (envBackend) return envBackend; // ✅ IMPORTANT: public base should match backend domain in prod
  if (typeof window !== "undefined" && window.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }
  return "http://localhost:3000";
})();

const defaultApiBase = (() => {
  if (envApiBase) return envApiBase;
  if (envBackend) return `${envBackend}/api`; // ✅ IMPORTANT: use backend base in prod
  if (isProdBuild) return "http://192.168.1.177:5002/api";
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${trimTrailingSlash(window.location.origin)}/api`;
  }
  return "http://localhost:5002/api";
})();

export const FRONTEND_URL = defaultFrontend;
export const API_BASE_URL = defaultApiBase;

export const buildFrontendUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${FRONTEND_URL}${normalizedPath}`;
};

export const buildApiUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
